// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".service-main-list{grid-column-gap:30px;display:grid;grid-template-columns:repeat(4,1fr);height:190px;justify-content:space-between}.service-main-list__card{width:100%}@media(max-width:768px){.service-main-list{grid-gap:20px;grid-template-columns:repeat(2,1fr);grid-template-rows:repeat(2,1fr);height:-moz-fit-content;height:fit-content}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
